/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./RestartPrescriptionDialog.vue?vue&type=template&id=919c70c0&scoped=true"
import script from "./RestartPrescriptionDialog.vue?vue&type=script&lang=js"
export * from "./RestartPrescriptionDialog.vue?vue&type=script&lang=js"
import style1 from "./RestartPrescriptionDialog.vue?vue&type=style&index=1&id=919c70c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919c70c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('919c70c0')) {
      api.createRecord('919c70c0', component.options)
    } else {
      api.reload('919c70c0', component.options)
    }
    module.hot.accept("./RestartPrescriptionDialog.vue?vue&type=template&id=919c70c0&scoped=true", function () {
      api.rerender('919c70c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/RestartPrescriptionDialog.vue"
export default component.exports